/* Vaste configuratiebalk onderaan de productpagina. Zie snippets/wave-sticky-bar.liquid. */
(function () {
  var bar = document.querySelector('[data-wsb]');
  if (!bar || bar.dataset.init) return;
  bar.dataset.init = '1';
  if (bar.parentNode !== document.body) document.body.appendChild(bar);

  var form = document.querySelector('form.js-product-form-main');
  if (!form) return;
  var cfg = document.querySelector('[data-wvc]');
  var sumEl = bar.querySelector('[data-wsb-sum]');
  var totEl = bar.querySelector('[data-wsb-total]');
  var addB = bar.querySelector('[data-wsb-add]');
  var goB = bar.querySelector('[data-wsb-go]');
  var variants = {};
  try { variants = JSON.parse(bar.dataset.variants || '{}'); } catch (e) {}
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var fmt = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: cur });
  var money = function (c) { return fmt.format(c / 100).replace(/,00$/, ',-'); };

  function realBtn() { return form.querySelector('[name="add"]'); }
  function variantId() { var i = form.querySelector('input[name="id"]'); return i ? i.value : ''; }

  function visible(el) { return el && el.isConnected && !el.hidden && el.offsetParent !== null; }

  /* Wat ontbreekt er nog? Geeft [{label, el}] terug. */
  function missing() {
    var out = [];
    var b = realBtn();
    if (!variantId() || (b && b.disabled)) out.push({ label: 'uitvoering', el: document.querySelector('.product-options') || form });
    if (!cfg) return out;
    var fs = cfg.querySelector('[data-wvc-filter-step]');
    if (visible(fs) && !fs.querySelector('input[name="wvc-filter"]:checked')) out.push({ label: 'filter', el: fs });
    var custom = cfg.querySelector('[data-wvc-custom]');
    if (custom && !custom.hidden) {
      custom.querySelectorAll('label.wvc__field').forEach(function (l) {
        if (l.hidden) return;
        var i = l.querySelector('input');
        if (i && !i.value.trim()) out.push({ label: 'gewenste kleur', el: custom });
      });
    }
    return out;
  }

  function summary() {
    var parts = [];
    var v = variants[variantId()];
    if (bar.dataset.single !== 'true' && v && v.t) parts.push(v.t);
    if (cfg) {
      cfg.querySelectorAll('input[type=radio]:checked').forEach(function (r) {
        if (!r.value || !r.dataset.label) return;
        parts.push(r.dataset.label.replace(/\s*\((mat|glanzend)\)\s*$/i, ''));
      });
    }
    return parts;
  }

  function update() {
    var parts = summary();
    var miss = missing();
    var html = parts.map(function (p) { return p.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }).join(' · ');
    if (miss.length) {
      var need = '<span class="wsb__need">Kies nog: ' + miss.map(function (m) { return m.label; }).filter(function (x, i, a) { return a.indexOf(x) === i; }).join(', ') + '</span>';
      html = html ? need + ' · ' + html : need;
    } else if (!html) {
      html = cfg ? 'Basisuitvoering' : '';
    }
    sumEl.innerHTML = html;

    var t = cfg && cfg.querySelector('[data-wvc-total]');
    if (t && t.textContent.trim()) {
      totEl.textContent = t.textContent.trim();
    } else {
      var v = variants[variantId()];
      if (v) totEl.textContent = money(v.p);
    }
    var b = realBtn();
    var soldOut = b && b.disabled && variantId();
    addB.disabled = !!soldOut;
    goB.hidden = miss.length > 0;
  }

  /* Tonen zodra de echte knop boven uit beeld is gescrold. */
  var on = false;
  function place() {
    var b = realBtn();
    if (!b) return;
    var r = b.getBoundingClientRect();
    var show = r.bottom < 0;
    if (show !== on) {
      on = show;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('wsb-on', on);
      if (on) { update(); document.body.style.setProperty('--wsb-h', bar.offsetHeight + 'px'); }
    }
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; place(); });
  }, { passive: true });
  window.addEventListener('resize', function () { if (on) document.body.style.setProperty('--wsb-h', bar.offsetHeight + 'px'); place(); });

  document.addEventListener('change', function () { setTimeout(update, 80); });
  document.addEventListener('input', function (e) { if (e.target && /^wvc-custom/.test(e.target.name || '')) update(); });
  document.addEventListener('click', function () { setTimeout(update, 200); });

  function goTo(el) {
    try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { el.scrollIntoView(); }
  }

  addB.addEventListener('click', function () {
    var b = realBtn();
    if (!b) return;
    var miss = missing();
    if (miss.length) {
      /* De echte knop laat de configurator de melding tonen en naar de stap scrollen. */
      b.click();
      setTimeout(function () { if (!document.querySelector('[data-wvc-filter-err]:not([hidden])')) goTo(miss[0].el); }, 50);
      return;
    }
    b.click();
  });

  goB.addEventListener('click', function () {
    var miss = missing();
    if (miss.length) { goTo(miss[0].el); update(); return; }
    var b = realBtn();
    if (!b) return;
    goB.classList.add('is-busy');
    if (cfg) {
      /* wave-configurator.js voegt basis + opties toe en gaat daarna naar /checkout. */
      form.dataset.wvcCheckout = '1';
      b.click();
      delete form.dataset.wvcCheckout;
      setTimeout(function () { goB.classList.remove('is-busy'); }, 4000);
      return;
    }
    var fd = new FormData(form);
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || 'Toevoegen mislukt'); });
      window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'checkout';
    }).catch(function (e) {
      goB.classList.remove('is-busy');
      var err = form.querySelector('.js-form-error');
      if (err) { err.textContent = e.message; err.hidden = false; goTo(err); }
    });
  });

  update();
  place();
})();
